import { IRiskAppScoreFormula } from '../types';
import { EntityService } from './EntityService';

export class RiskAppScoreFormulaService extends EntityService<IRiskAppScoreFormula> {
    constructor() {
        super(`/RiskAppScoreFormulas`);
    }
}